import { z } from 'zod'

import { IntegrationType } from 'common/actions/integrations/common/constants/IntegrationType'
import { CHANNELS_ORDER } from 'common/actions/integrations/TikTokAds/constants'

const Types = Object.values(IntegrationType)
const ConnectedIntegration = z.object({ allowed_actions: z.array(z.string()) })
export const IntegrationShortSchema = z.object({})
Types.forEach((type) => IntegrationShortSchema.extend({ [type]: ConnectedIntegration }))

const ChannelSchema = z.object({})
const Channels = z.object({
  connected: z.boolean(),
  event_set_id: z.string().optional(),
  event_set_name: z.string().optional(),
})
CHANNELS_ORDER.forEach((type) => ChannelSchema.extend({ [type]: Channels }))

const LinkingSettingsSchema = z
  .unknown()
  .or(
    z.object({
      email_custom_field_name: z.string().nullable(),
      email_custom_field_id: z.number().nullable(),
      email_custom_field_type: z.string().nullable(),
    }),
  )
  .nullable()

const AccountDataSchema = z.object({
  // hubspot
  token: z.string().optional(),
  user: z.string().optional(),
  hub_domain: z.string().optional(),
  token_type: z.string().optional(),
  user_id: z.number().optional(),
  app_id: z.number().optional(),
  hub_id: z.number().optional(),
  expires_in: z.number().optional(),
  scopes: z.array(z.string()).optional(),
  signed_access_token: z
    .object({
      expiresAt: z.number(),
      scopes: z.string(),
      signature: z.string(),
      newSignature: z.string(),
      hublet: z.string(),
      trialScopes: z.string(),
      trialScopeToScopeGroupPks: z.string(),
      isUserLevel: z.boolean(),
      isServiceAccount: z.boolean().optional(),
      installingUserId: z.number().optional(),
      hubId: z.number(),
      userId: z.number(),
      appId: z.number(),
    })
    .optional(),

  // hotmart
  wh_url: z.string().optional(),

  // google_sheets
  id: z.string().optional(),
  name: z.string().optional(),
  given_name: z.string().optional(),
  family_name: z.string().optional().nullable(),
  picture: z.string().optional(),
  email_verified: z.boolean().optional(),
  locale: z.string().optional().nullable(),

  // tiktok_ads
  display_name: z.string().optional(),
  core_user_id: z.string().optional(),
  avatar_url: z.string().optional(),
  create_time: z.number().optional(),
  connection_finalized: z.boolean().optional(),
  channels: ChannelSchema.optional(),
  ad_account: z
    .object({
      advertiser_id: z.string(),
      advertiser_name: z.string(),
    })
    .optional(),
  consent: z
    .object({
      email: z.boolean(),
      phone: z.boolean(),
    })
    .optional(),

  // common
  email: z.string().optional(), // tiktok_ads | google_sheets
})

export const IntegrationSchema = z.object({
  type: z.nativeEnum(IntegrationType),
  account_id: z.string(),
  account_name: z.string(),
  status: z.string(),
  account_data: AccountDataSchema.or(z.array(z.void()).length(0)),
  linking_settings: LinkingSettingsSchema,
  sync_settings: z.unknown().nullable(),
})

export type Integration = z.infer<typeof IntegrationSchema>
